// type guard used to filter null and undefined values out of an array and ensure the type of the
// resulting array doesn't include null or undefined. to be used in an array filter like so:
//   const filteredArray = array.filter(isNotNullOrUndefined);
export const isNotNullOrUndefined = <T>(value: T | null | undefined): value is T =>
  value !== null && value !== undefined;
